import { createSlice } from '@reduxjs/toolkit';
import { fetchViewers } from './viewer.actions';

const initialState = {
  viewers: [],
  metaData: { total: 0, page: 1, perPage: 20 },
  isLoadingViewers: false
};

const viewerSlice = createSlice({
  name: 'viewer',
  initialState,
  reducers: {
    clearViewerState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(fetchViewers.pending, (state) => {
      state.isLoadingViewers = true;
    });
    builder.addCase(fetchViewers.fulfilled, (state, action) => {
      state.viewers = action.payload?.data || [];
      state.metaData = action.payload?.metaData || state.metaData;
      state.isLoadingViewers = false;
    });
    builder.addCase(fetchViewers.rejected, (state) => {
      state.isLoadingViewers = false;
    });
  }
});

export const { clearViewerState } = viewerSlice.actions;

export default viewerSlice.reducer;
